import { IAgentRuntime } from "../../models/AgentRuntime.model";

export const FakeAgentRuntime: IAgentRuntime[] = [
  // {
  //   label: "Product Test Automation Team",
  //   value: "workflow4",
  //   workflow: [
  //     {
  //       tabName: "Test Case Analyser Agent",
  //       activeFilePath:
  //         "workflow/DesignAnalysis/testcase/5328669.0_TC02_Inbound_Fed_pacs.008_README.md",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "5328669.0_TC02_Inbound_Fed_pacs.008_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328669.0_TC02_Inbound_Fed_pacs.008_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF_README.md",
  //             },
  //             {
  //               fileName:
  //                 "5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2_README.md",
  //               path: "workflow/DesignAnalysis/testcase/5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2_README.md",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Test Data Preparation Agent",
  //       activeFilePath:
  //         "workflow/DesignCodeGen/testcase/TC02-FEDSIM_pacs.008_CTRC_on_us _RPR.xml",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "TC02-FEDSIM_pacs.008_CTRC_on_us _RPR.xml",
  //               path: "workflow/DesignCodeGen/testcase/TC02-FEDSIM_pacs.008_CTRC_on_us _RPR.xml",
  //             },
  //             {
  //               fileName:
  //                 "TC03-FEDSIM_CustomerCreditTransfer_Scenario5_Step1_pacs.008_CTRC_SWF_Repair.xml",
  //               path: "workflow/DesignCodeGen/testcase/TC03-FEDSIM_CustomerCreditTransfer_Scenario5_Step1_pacs.008_CTRC_SWF_Repair.xml",
  //             },
  //             {
  //               fileName: "TC04-FEDSIM_pacs.008_CTRC_on_us_NotonFile.xml",
  //               path: "workflow/DesignCodeGen/testcase/TC04-FEDSIM_pacs.008_CTRC_on_us_NotonFile.xml",
  //             },
  //             {
  //               fileName:
  //                 "TC05-FEDSIM_CustomerCreditTransfer_Scenario5_Step1_pacs.008_CTRC_CHP.xml",
  //               path: "workflow/DesignCodeGen/testcase/TC05-FEDSIM_CustomerCreditTransfer_Scenario5_Step1_pacs.008_CTRC_CHP.xml",
  //             },
  //             {
  //               fileName: "TC06-07-FEDSIM_pacs.008_CTRC_on_us_OFAC.xml",
  //               path: "workflow/DesignCodeGen/testcase/TC06-07-FEDSIM_pacs.008_CTRC_on_us_OFAC.xml",
  //             },
  //             {
  //               fileName: "fed-testdata-62790.xlsx",
  //               path: "workflow/DesignCodeGen/testcase/fed-testdata-62790.xlsx",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "BDD Test Generation Agent",
  //       activeFilePath:
  //         "workflow/DesignCodeGen/testcase/5328669.0_TC02_Inbound_Fed_pacs.008.feature",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "5328669.0_TC02_Inbound_Fed_pacs.008.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328669.0_TC02_Inbound_Fed_pacs.008.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF.feature",
  //             },
  //             {
  //               fileName: "5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF.feature",
  //             },
  //             {
  //               fileName:
  //                 "5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2.feature",
  //               path: "workflow/DesignCodeGen/testcase/5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2.feature",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "BDD Test Scoring Agent",
  //       activeFilePath:
  //         "workflow/DesignScore/testcase/5328669.0_TC02_Inbound_Fed_pacs.008_evaluation.md",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "5328669.0_TC02_Inbound_Fed_pacs.008_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328669.0_TC02_Inbound_Fed_pacs.008_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328670.0_TC03_Inbound_Fed_pacs.008_REPAIR_onfile_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328671.0_TC04_Inbound_Fed_pacs.008_REPAIR_notonfile_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328672.0_TC05_Inbound_Fed_pacs.008_REPAIR_FED_CHP_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328673.0_TC06_Inbound_Fed_pacs.008_REPAIR_OFAC_approve_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328674.0_TC07_Inbound_Fed_pacs.008_REPAIR_OFAC_seize_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328675.0_TC08_Inbound_Fed_pacs.008_REPAIR_SWF_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328676.0_TC09_Inbound_Fed_pacs.008_STP_SWF_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2_evaluation.md",
  //               path: "workflow/DesignScore/testcase/5328677.0_TC10_Inbound_Fed_pacs.008_REPAIR_Crossbank_QA2_evaluation.md",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Database Agent",
  //       activeFilePath: "workflow/DesignCodeGen/testcase/mongodb_summary.md",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "mongodb_summary.md",
  //               path: "workflow/DesignCodeGen/testcase/mongodb_summary.md",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Test Squish Bundle Agent",
  //       activeFilePath: "workflow/DesignCodeGen/testcase/SQUISH_FORMAT.zip",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "SQUISH_FORMAT.zip",
  //               path: "workflow/DesignCodeGen/testcase/SQUISH_FORMAT.zip",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  //   historyRuns: [
  //     {
  //       configId: "CONF-000001",
  //       runId: "PAIWF-08202302",
  //       status: "success",
  //       runDateTime: "2024-08-20T23:02:29.833Z",
  //       tokensUsed: "6013",
  //       score: 75,
  //     },
  //     {
  //       configId: "CONF-000001",
  //       runId: "PAIWF-08202304",
  //       status: "success",
  //       runDateTime: "2024-08-20T23:02:29.833Z",
  //       tokensUsed: "6013",
  //       score: 84,
  //     },
  //   ],
  // },
  // {
  //   label: "NTC Test Automation Team",
  //   value: "workflow2",
  //   workflow: [
  //     {
  //       tabName: "Generate Test Pattern Agent",
  //       activeFilePath:
  //         "workflow/DesignCodeGen/testcase/TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //               path: "workflow/DesignCodeGen/testcase/TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //             },
  //             {
  //               fileName:
  //                 "TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //               path: "workflow/DesignCodeGen/testcase/TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //             },
  //             {
  //               fileName:
  //                 "TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //               path: "workflow/DesignCodeGen/testcase/TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG.json",
  //             },
  //             {
  //               fileName:
  //                 "TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR.json",
  //               path: "workflow/DesignCodeGen/testcase/TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR.json",
  //             },
  //             {
  //               fileName:
  //                 "TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF.json",
  //               path: "workflow/DesignCodeGen/testcase/TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF.json",
  //             }
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "BDD Test Generation Agent",
  //       activeFilePath:
  //         "workflow/DesignCodeGen/testcase/feature_TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "feature_TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //               path: "workflow/DesignCodeGen/testcase/feature_TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //             },
  //             {
  //               fileName:
  //                 "feature_TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //               path: "workflow/DesignCodeGen/testcase/feature_TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //             },
  //             {
  //               fileName:
  //                 "feature_TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //               path: "workflow/DesignCodeGen/testcase/feature_TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG.feature",
  //             },
  //             {
  //               fileName:
  //                 "feature_TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR.feature",
  //               path: "workflow/DesignCodeGen/testcase/feature_TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR.feature",
  //             },
  //             {
  //               fileName:
  //                 "feature_TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF.feature",
  //               path: "workflow/DesignCodeGen/testcase/feature_TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF.feature",
  //             }
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "BDD Test Scoring Agent",
  //       activeFilePath:
  //         "workflow/DesignScore/testcase/TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //               path: "workflow/DesignScore/testcase/TC01_MT103_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //               path: "workflow/DesignScore/testcase/TC02_MT202_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //               path: "workflow/DesignScore/testcase/TC03_MT202 COV_FED receipts that has beneficiary on NTL_NLX_FED - SWG_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR_evaluation.md",
  //               path: "workflow/DesignScore/testcase/TC04_1000, 1008_FED receipts that has beneficiary on NTC_FED - LTR_evaluation.md",
  //             },
  //             {
  //               fileName:
  //                 "TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF_evaluation.md",
  //               path: "workflow/DesignScore/testcase/TC05_MT103_GPI Tracker update - MTS_FED, CHP, SWF_evaluation.md",
  //             }
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Database Agent",
  //       activeFilePath: "workflow/DesignCodeGen/testcase/ntc_mongodb_summary.md",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "ntc_mongodb_summary.md",
  //               path: "workflow/DesignCodeGen/testcase/ntc_mongodb_summary.md",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //     {
  //       tabName: "Test Squish Bundle Agent",
  //       activeFilePath: "workflow/DesignCodeGen/testcase/SQUISH_FORMAT.zip",
  //       fileStructure: [
  //         {
  //           fileName: "testcase",
  //           files: [
  //             {
  //               fileName: "SQUISH_FORMAT.zip",
  //               path: "workflow/DesignCodeGen/testcase/SQUISH_FORMAT.zip",
  //             },
  //           ],
  //         },
  //       ],
  //     },
  //   ],
  //   historyRuns: [
  //     {
  //       configId: "CONF-000001",
  //       runId: "PAIWF-11202404",
  //       status: "success",
  //       runDateTime: "2024-11-04T23:02:29.833Z",
  //       tokensUsed: "6013",
  //       score: 75,
  //     },
  //     {
  //       configId: "CONF-000001",
  //       runId: "PAIWF-11202403",
  //       status: "success",
  //       runDateTime: "2024-08-20T23:02:29.833Z",
  //       tokensUsed: "6013",
  //       score: 84,
  //     },
  //   ],
  // },
  {
    "label": "EJB to gRPC Conversion Team",
    "value": "workflow3",
    "workflow": [
      {
        "tabName": "Input",
        "activeFilePath": "workflow/DesignInput/bean/ScanlineBean.java",
        "fileStructure": [
          {
            "fileName": "bean",
            "files": [
              {
                "fileName": "ScanlineBean.java",
                "path": "workflow/DesignInput/bean/ScanlineBean.java"
              }
            ]
          },
          {
            "fileName": "models",
            "files": [
              {
                "fileName": "RTDSRequest.java",
                "path": "workflow/DesignInput/models/RTDSRequest.java"
              },
              {
                "fileName": "RTDSResponse.java",
                "path": "workflow/DesignInput/models/RTDSResponse.java"
              },
              {
                "fileName": "ValidationRequest.java",
                "path": "workflow/DesignInput/models/ValidationRequest.java"
              },
              {
                "fileName": "ValidationResponse.java",
                "path": "workflow/DesignInput/models/ValidationResponse.java"
              },
              {
                "fileName": "MAMAccount.java",
                "path": "workflow/DesignInput/models/MAMAccount.java"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Analysis",
        "activeFilePath": "workflow/DesignAnalysis/bean/ScanlineBean.md",
        "fileStructure": [
          {
            "fileName": "bean",
            "files": [
              {
                "fileName": "ScanlineBean.md",
                "path": "workflow/DesignAnalysis/bean/ScanlineBean.md"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Proto Generation",
        "activeFilePath": "workflow/DesignCodeGen/proto/scanline.proto",
        "fileStructure": [
          {
            "fileName": "proto",
            "files": [
              {
                "fileName": "scanline.proto",
                "path": "workflow/DesignCodeGen/proto/scanline.proto"
              }
            ]
          }
        ]
      },
      {
        "tabName": "gRPC Service Generation",
        "activeFilePath": "workflow/DesignCodeGen/service/ScanlineServiceImpl.java",
        "fileStructure": [
          {
            "fileName": "service",
            "files": [
              {
                "fileName": "ScanlineServiceImpl.java",
                "path": "workflow/DesignCodeGen/service/ScanlineServiceImpl.java"
              }
            ]
          }
        ]
      },
      {
        "tabName": "gRPC ServerClient Generation",
        "activeFilePath": "workflow/DesignCodeGen/grpc/GrpcServer.java",
        "fileStructure": [
          {
            "fileName": "grpc",
            "files": [
              {
                "fileName": "GrpcServer.java",
                "path": "workflow/DesignCodeGen/grpc/GrpcServer.java"
              },
              {
                "fileName": "ScanlineClient.java",
                "path": "workflow/DesignCodeGen/grpc/ScanlineClient.java"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Review",
        "activeFilePath": "workflow/DesignReview/grpc/ScanlineServiceReview.md",
        "fileStructure": [
          {
            "fileName": "grpc",
            "files": [
              {
                "fileName": "ScanlineServiceReview.md",
                "path": "workflow/DesignReview/grpc/ScanlineServiceReview.md"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Score",
        "activeFilePath": "workflow/DesignScore/grpc/ScanlineServiceScoreCard.md",
        "fileStructure": [
          {
            "fileName": "grpc",
            "files": [
              {
                "fileName": "ScanlineServiceScoreCard.md",
                "path": "workflow/DesignScore/grpc/ScanlineServiceScoreCard.md"
              }
            ]
          }
        ]
      }
    ],
    "historyRuns": [
      {
        "configId": "CONF-000001",
        "runId": "PAIWF-08041922",
        "status": "success",
        "runDateTime": "2024-08-04T03:46:29.833Z",
        "tokensUsed": "4053",
        "score": 75
      }
    ]
  },
  {
    "label": "Oracle to MongoDB Conversion Team",
    "value": "workflow4",
    "workflow": [
      {
        "tabName": "Input",
        "activeFilePath": "workflow/DesignInput/dal/VRuleSelectionDataAccess.java",
        "fileStructure": [
          {
            "fileName": "dal",
            "files": [
              {
                "fileName": "VRuleSelectionDataAccess.java",
                "path": "workflow/DesignInput/dal/VRuleSelectionDataAccess.java"
              }
            ]
          },
          {
            "fileName": "dbscripts",
            "files": [
              {
                "fileName": "SPKG_RTDS_VRULE_SELECTION.spkgb",
                "path": "workflow/DesignInput/dbscripts/SPKG_RTDS_VRULE_SELECTION.spkgb"
              },
              {
                "fileName": "ddl_scripts.sql",
                "path": "workflow/DesignInput/dbscripts/ddl_scripts.sql"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Analyze Data Access Layer",
        "activeFilePath": "workflow/DesignAnalysis/dal/VRuleSelectionDataAccess.md",
        "fileStructure": [
          {
            "fileName": "dal",
            "files": [
              {
                "fileName": "VRuleSelectionDataAccess.md",
                "path": "workflow/DesignAnalysis/dal/VRuleSelectionDataAccess.md"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Analyze Oracle Package",
        "activeFilePath": "workflow/DesignAnalysis/db/sf_select_vrule_selection.md",
        "fileStructure": [
          {
            "fileName": "db",
            "files": [
              {
                "fileName": "sf_select_vrule_selection.md",
                "path": "workflow/DesignAnalysis/db/sf_select_vrule_selection.md"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Generate MongoDB Schema",
        "activeFilePath": "workflow/DesignCodeGen/schema/Schema.json",
        "fileStructure": [
          {
            "fileName": "schema",
            "files": [
              {
                "fileName": "Schema.json",
                "path": "workflow/DesignCodeGen/schema/Schema.json"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Generate Spring DAL",
        "activeFilePath": "workflow/DesignCodeGen/dal/VRuleSelectionDataAccess.java",
        "fileStructure": [
          {
            "fileName": "dal",
            "files": [
              {
                "fileName": "VRuleSelectionDataAccess.java",
                "path": "workflow/DesignCodeGen/dal/VRuleSelectionDataAccess.java"
              },
              {
                "fileName": "BillerRepository.java",
                "path": "workflow/DesignCodeGen/dal/BillerRepository.java"
              },
              {
                "fileName": "models.java",
                "path": "workflow/DesignCodeGen/dal/models.java"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Review",
        "activeFilePath": "workflow/DesignReview/dal/VRuleSelectionDataAccessReview.md",
        "fileStructure": [
          {
            "fileName": "dal",
            "files": [
              {
                "fileName": "VRuleSelectionDataAccessReview.md",
                "path": "workflow/DesignReview/dal/VRuleSelectionDataAccessReview.md"
              }
            ]
          }
        ]
      },
      {
        "tabName": "Score",
        "activeFilePath": "workflow/DesignScore/dal/VRuleSelectionDataAccessScoreCard.md",
        "fileStructure": [
          {
            "fileName": "dal",
            "files": [
              {
                "fileName": "VRuleSelectionDataAccessScoreCard.md",
                "path": "workflow/DesignScore/dal/VRuleSelectionDataAccessScoreCard.md"
              }
            ]
          }
        ]
      }
    ],
    "historyRuns": [
      {
        "configId": "CONF-000002",
        "runId": "PAIWF-08041931",
        "status": "success",
        "runDateTime": "2024-08-04T04:46:29.833Z",
        "tokensUsed": "6013",
        "score": 75
      }
    ]
  }    
];
